import React, { useEffect, useMemo, useState } from 'react'
import { EditCartItemProps, SipValidationType } from '../types'
import { Box, Grid, Skeleton, Theme, Typography, useTheme } from '@mui/material'
import { Formik, useFormik } from 'formik';
import { SipScheme } from './Scheme';
import dayjs from 'dayjs';
import { getMandatesList } from '../../../redux-store/actions/investorProfile';
import { MandateListItem, MandatesListResBody } from '../../../redux-store/types/investorProfile';
import { useDispatch, useSelector } from 'react-redux';
import { RootStateType } from '../../../redux-store/reducers';
import { MpowerValidationType } from '../../investorOverview/types';
import { InvestmentFundType } from '../../../redux-store/types/api-types';
import { formatCurrency } from '../../../utils/utilityFunctions';
import { CustomeBlueDatePicker, CustomeBlueDropDown, CustomeModalButton, CustomeNumberInput } from '../../investorOverview/transcation/FromInput';
import { WEEKLYDAYS } from '../../../utils/constant';
import MFCheckbox from '../../../lib/formik/Checkbox';

type Props = {
    data: EditCartItemProps
    currentTransactionType: string
    validation: SipValidationType,
    folio: string[]
    schemeLoading: boolean
    scheme: InvestmentFundType

}

export const handleDateValidation = (ArrayOfDate: Array<string | number>, date: dayjs.Dayjs) => {

    if (ArrayOfDate?.length === 0) {
        return false
    }
    if (typeof ArrayOfDate?.[0] === 'number') {
        return !ArrayOfDate?.includes(dayjs(date).date());
    }

    if (typeof ArrayOfDate?.[0] === 'string') {
        const capitalizedDays = ArrayOfDate.map(day =>
            day.toString().charAt(0) + day.toString().slice(1).toLowerCase()
        );
        const day = capitalizedDays.map(item => WEEKLYDAYS.indexOf(item))
        return !day?.includes(dayjs(date).day());
    }
    return false
}

export default function Sip(props: Props) {
    const theme = useTheme()
    const dispatch = useDispatch()

    const { investorClientId } = useSelector((store: RootStateType) => store.id)
    const { data, currentTransactionType, validation, folio, schemeLoading, scheme } = props
    const { onSave, sipAmount, frequency, onCancel, noOfInstallments, sipDate, mandate, isLoading, activeCategory, folioNumber } = data
    const [activeMandateList, setActiveMandateList] = useState<MandateListItem[]>([]);
    const [mandatesListRes, setMandatesListRes] = useState<MandatesListResBody>({} as MandatesListResBody);
    // sheme
    const schemeValidation = SipScheme({ scheme, sipAmount, frequency, noOfInstallments, sipDate, activeCategory, mandate })
    const { selectedPortfolio } = useSelector((state: RootStateType) => state.selectedPortfiolio)
    const { locale, currencyCode } = useSelector((store: RootStateType) => store.currencyInfo);




    useEffect(() => {
        const fetch = async () => {
            if (investorClientId) {
                const list = await (dispatch(getMandatesList({ clientCode: investorClientId, status: "Active", portfolioId: selectedPortfolio?.value })) as unknown as Promise<MandatesListResBody>);
                setMandatesListRes(list);
                setActiveMandateList(list?.mandates || []);
            }
        }
        fetch();
    }, [investorClientId])

    function drowDownDateFormate(array: Array<MandateListItem>) {
        return array?.map((item: MandateListItem) => {
            return {
                label: item?.displayText,
                value: item?.mandateId
            }
        })
    }



    // handleSubmit
    function handleSubmitBtn(formValues: any) {
        formValues.sipDate = dayjs(formValues.sipDate).format('DD/MM/YYYY')
        onSave(
            data.id,
            currentTransactionType,
            {
                amount: formValues.sipAmount,
                frequency: formValues.frequency,
                noOfInstallment: formValues.noOfInstallments,
                sipDate: formValues.sipDate,
                mandateId: formValues.mandates,
                ...(activeCategory === "New Purchase" ? { folio: formValues.folios } : {})
            }
        )
    }

    const frequencyArray = scheme?.frequencies?.filter(item => item.frequency && item.transactionType === 'SIP')
    const Daily = scheme?.validations?.filter((item) => item?.frequency === 'DAILY' && item?.transactionType === 'SIP')?.[0]
    const Weekly = scheme?.validations?.filter((item) => item?.frequency === 'WEEKLY' && item?.transactionType === 'SIP')?.[0]
    const WeeklyDays = scheme?.validations?.filter((item) => item?.frequency === 'WEEKLYDAYS' && item?.transactionType === 'SIP')?.[0]
    const Monthly = scheme?.validations?.filter((item) => item?.frequency === 'MONTHLY' && item?.transactionType === 'SIP')?.[0]
    const Quarterly = scheme?.validations?.filter((item) => item?.frequency === 'QUARTERLY' && item?.transactionType === 'SIP')?.[0]
    const Yearly = scheme?.validations?.filter((item) => item?.frequency === 'YEARLY' && item?.transactionType === 'SIP')?.[0]

    const sipMinAmount = (key = 'minimumInstallmentAmount' as keyof MpowerValidationType, frequency: string) => {

        if (frequency === 'WEEKLY') {
            return Weekly?.[key]
        } else if (frequency === 'MONTHLY') {
            return Monthly?.[key]
        } else if (frequency === 'QUARTERLY') {
            return Quarterly?.[key]
        } else if (frequency === 'YEARLY') {
            return Yearly?.[key]
        } else if (frequency === 'DAILY') {
            return Daily?.[key]
        } else if (frequency === 'WEEKLYDAYS') {
            return WeeklyDays?.[key]
        } else {
            return 0
        }
    }

    return (
        <>
            {/* {(mandatesListRes?.pendingCount ?? 0) === 0 && activeMandateList.length === 0
                &&
                <>
                    <Box m={'auto auto'}>
                        <Typography
                            variant="h6"
                            color={theme.palette.error[500]}
                            sx={{ textAlign: 'center', m: 4 }}
                        >
                            No active mandates are present. Please wait until they are activated.
                        </Typography>
                    </Box>
                </>
            }
            {(mandatesListRes?.pendingCount ?? 0) > 0 && activeMandateList.length === 0
                &&
                <>
                    <Box m={'auto auto'}>
                        <Typography
                            variant="h6"
                            color={theme.palette.error[500]}
                            sx={{ textAlign: 'center', m: 4 }}
                        >
                            Please approve the SIP mandate authorization request received from BSE in your email.
                        </Typography>
                    </Box>
                </>
            } */}
            {/* {activeMandateList.length > 0 && */}
            <Formik
                enableReinitialize
                initialValues={{
                    sipAmount: sipAmount || '0',
                    frequency: frequency || '',
                    noOfInstallments: noOfInstallments || '0',
                    sipDate: dayjs(sipDate, 'DD/MM/YYYY') || '',
                    mandates: mandate || '',
                    ...(activeCategory === "New Purchase" ? { folios: folioNumber } : {})
                }}
                validationSchema={schemeValidation}
                onSubmit={handleSubmitBtn}>

                {(formik) => (
                    <Box component={'form'} onSubmit={formik.handleSubmit} noValidate>
                        <Grid container spacing={2}>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeNumberInput
                                    isLoading={schemeLoading}
                                    disable={isLoading}
                                    textType="number"
                                    label='SIP Amount'
                                    name={`sipAmount`}
                                    defaultValue={`${sipAmount}`}
                                    minlabel={`Min:${formatCurrency({ value: Number(sipMinAmount('minimumInstallmentAmount', formik.values.frequency) ?? 0), locale, currencyCode })}`}
                                    removeIcons={true}
                                    warningText={'amount'}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeBlueDropDown
                                    name={`frequency`}
                                    disabled={isLoading}
                                    isLoading={schemeLoading}
                                    label='Frequency'
                                    list={frequencyArray?.map(item => ({ value: item.frequency, label: item.frequency })) as any}
                                />
                            </Grid>
                            {schemeLoading ? (
                                <Skeleton variant="rectangular" width={'100%'} height={60}/>
                            )
                                :
                                (<Box sx={{ marginLeft: 2, mt: 1, width: '100%', padding: '4px 0px 4px 15px', backgroundColor: theme.palette.primary[50], borderRadius: 2 }}>
                                    <MFCheckbox
                                        name={`firstOrder`}
                                        label={'Pay 1st Installment Today'}
                                        checked={data?.firstOrder ?? false}
                                        disabled={true}
                                    />
                                    {/* <Typography variant="body_400"
                                        color={theme.palette.text.secondary}
                                        sx={{ letterSpacing: '0.2px', ml: 3.5, mt: -1 }}
                                    >
                                        Kickstart your wealth journey-pay your first SIP today!
                                    </Typography> */}
                                </Box>
                                )}
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeNumberInput
                                    isLoading={schemeLoading}
                                    disable={isLoading}
                                    textType="number"
                                    label='No. of Installments'
                                    name={`noOfInstallments`}
                                    defaultValue={`${noOfInstallments}`}
                                    minValue={sipMinAmount('minimumInstallments', formik.values.frequency)}
                                    removeIcons={true}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12}>
                                <CustomeBlueDatePicker
                                    // disabled={isLoading}
                                    disabled={true}
                                    name={`sipDate`}
                                    isLoading={schemeLoading}
                                    disablePast={true}
                                    // disableDateList={getValidation?.investmentDates}
                                    shouldDisableDate={(date: dayjs.Dayjs) => handleDateValidation(sipMinAmount('investmentDates', formik.values.frequency) || [], date)}
                                    minDate={dayjs().add(1, 'day')}
                                />
                            </Grid>
                            <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                                {/* <CustomeBlueDropDown
                                    name={`mandates`}
                                    isLoading={schemeLoading}
                                    disabled={isLoading}
                                    label='Mandate'
                                    list={drowDownDateFormate(activeMandateList)}
                                /> */}
                                <Box>
                                    <Typography
                                        variant="body_500"
                                        sx={(theme: Theme) => ({
                                            textWrap: 'nowrap',
                                            overflow: 'hidden',
                                            textOverflow: 'ellipsis',
                                            whiteSpace: 'nowrap',
                                            color: theme.palette.text.secondary,
                                            mb: 0.7,
                                            opacity: 0.5,
                                            fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' }
                                        })}
                                    >
                                        Mandate
                                    </Typography>
                                    {schemeLoading ? (
                                        <Skeleton variant="text" animation="wave" width={100} height={50} />
                                    ) : (
                                        <Box
                                            sx={(theme: Theme) => ({
                                                display: "flex",
                                                alignItems: "center",
                                                background: theme.palette.primary[50],
                                                padding: '15px',
                                                borderRadius: '10px',
                                                opacity: 0.5,
                                                cursor: 'not-allowed',
                                            })}
                                        >
                                            <Typography
                                                variant="body_500"
                                                sx={(theme: Theme) => ({
                                                    color: theme.palette.primary[500],
                                                    opacity: 0.9,
                                                    fontSize: { lg: '16px', md: '16px', sm: '14px', xs: '14px' }
                                                })}
                                            >
                                                {data?.mandatesDisplayText ?? ""}
                                            </Typography>
                                        </Box>
                                    )}
                                </Box>
                            </Grid>
                            {activeCategory === "New Purchase" &&
                                <Grid item lg={6} md={6} sm={12} xs={12} sx={{ paddingBottom: "20px" }}>
                                    <CustomeBlueDropDown
                                        isLoading={schemeLoading}
                                        // disabled={isLoading}
                                        disabled
                                        label='Select Folio'
                                        name={'folios'}
                                        list={folio?.map((item: string) => ({ label: item, value: item }))}
                                    />
                                </Grid>
                            }
                            <Grid
                                item
                                container
                                xs={12}
                                mt={2}
                                sx={{
                                    justifyContent: "center",
                                    alignItems: "center",
                                    borderTop: `0.5px solid ${theme.palette.text.secondary}B2`
                                }}
                            >
                                <Grid
                                    item
                                    container
                                    xs={9.5}
                                    sx={{
                                        columnGap: "35px",
                                        flexWrap: "nowrap",
                                        paddingTop: "30px",
                                    }}
                                >
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <CustomeModalButton
                                            disabled={isLoading || schemeLoading}
                                            onClick={() => onCancel()}
                                            btnText='Cancel'
                                            variant='outlined'
                                            boxStyle={{
                                                color: theme.palette.text.primary,
                                            }}
                                        />
                                    </Grid>
                                    <Grid
                                        item
                                        xs={6}
                                    >
                                        <CustomeModalButton
                                            variant='contained'
                                            disabled={!formik.dirty || schemeLoading}
                                            isLoading={isLoading}
                                            btnText='Save Changes'
                                            type='submit'
                                        />
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Box>
                )}

            </Formik>
            {/* } */}
        </>
    )
}